import * as SliderPrimitive from '@radix-ui/react-slider';

import { Input } from './input';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

export type RangeSliderProps = {
  value?: number[];
  onValueChange: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
};

const RangeSlider = ({
  value,
  onValueChange,
  min = 0,
  max = 100000,
  step = 500,
}: RangeSliderProps) => {
  return (
    <div className="w-full flex flex-col gap-4 px-3 py-2">
      <TooltipProvider>
        <SliderPrimitive.Root
          className="relative flex items-center select-none touch-none w-full h-5"
          value={value}
          min={min}
          max={max}
          step={step}
          onValueChange={onValueChange}
        >
          <SliderPrimitive.Track className="bg-black/10 relative grow rounded-full h-1">
            <SliderPrimitive.Range className="absolute bg-primary rounded-full h-full" />
          </SliderPrimitive.Track>
          <Tooltip>
            <TooltipTrigger asChild>
              <SliderPrimitive.Thumb
                className="cursor-pointer block w-5 h-5 bg-white shadow-[0_2px_10px_var(--black-a7)] rounded-[10px] border border-primary hover:bg-[--violet-3] focus:outline-none focus:shadow-[0_0_0_5px_var(--black-a8)]"
                aria-label="Minimum"
              />
            </TooltipTrigger>
            <TooltipContent>{value && <p>{value[0]} $</p>}</TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <SliderPrimitive.Thumb
                className="cursor-pointer block w-5 h-5 bg-white shadow-[0_2px_10px_var(--black-a7)] rounded-[10px] border border-primary hover:bg-[--violet-3] focus:outline-none focus:shadow-[0_0_0_5px_var(--black-a8)]"
                aria-label="Maximum"
              />
            </TooltipTrigger>
            <TooltipContent>{value && <p>{value[1]} $</p>}</TooltipContent>
          </Tooltip>
        </SliderPrimitive.Root>
      </TooltipProvider>
      <span className="w-full flex items-center justify-between gap-4">
        <Input
          type="number"
          value={value ? value[0] : min}
          onChange={(v) => {
            if (!value) return;
            const newMin = Number.parseFloat(v.currentTarget.value) || 0;
            onValueChange([newMin, value[1]]);
          }}
          endAdornment="$"
        />
        <Input
          type="number"
          value={value ? value[1] : max}
          onChange={(v) => {
            if (!value) return;
            const newMax = Number.parseFloat(v.currentTarget.value) || 0;
            onValueChange([value[0], newMax]);
          }}
          endAdornment="$"
        />
      </span>
    </div>
  );
};

export default RangeSlider;
